import React, { Fragment, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";

import styles from "./basetopnav.css";

export function BaseTopNav({ children, className = "" }) {
  const slots = React.Children.toArray(children);
  const [isTopnavReady, setIsTopnavReady] = useState(false);

  useEffect(function setTopNav() {
    const topNavDom = document.getElementById("topnavcontainer");
    if (topNavDom) {
      className && topNavDom.classList.add(className);
      setIsTopnavReady(true);
    }
  }, []);

  const LeftRenderer = slots.find(
    (child) => child.type === BaseTopNav.LeftRenderer
  ) || <BaseTopNav.LeftRenderer />;
  const MiddleRenderer = slots.find(
    (child) => child.type === BaseTopNav.MiddleRenderer
  ) || <BaseTopNav.MiddleRenderer />;
  const RightRenderer = slots.find(
    (child) => child.type === BaseTopNav.RightRenderer
  ) || <BaseTopNav.RightRenderer />;

  return (
    isTopnavReady &&
    createPortal(
      <Fragment>
        {LeftRenderer}
        {MiddleRenderer}
        {RightRenderer}
      </Fragment>,
      document.getElementById("topnavcontainer")
    )
  );
}
BaseTopNav.propTypes = {
  children: PropTypes.node.isRequired
};

function LeftRenderer({ children }) {
  return <div className={styles.leftRenderer}>{children}</div>;
}
LeftRenderer.propTypes = {
  children: PropTypes.node.isRequired
};

function RightRenderer({ children }) {
  return <div className={styles.rightRenderer}>{children}</div>;
}
RightRenderer.propTypes = {
  children: PropTypes.node.isRequired
};

function MiddleRenderer({ children }) {
  return <div className={styles.middleRenderer}>{children}</div>;
}
MiddleRenderer.propTypes = {
  children: PropTypes.node.isRequired
};

BaseTopNav.LeftRenderer = LeftRenderer;

BaseTopNav.RightRenderer = RightRenderer;

BaseTopNav.MiddleRenderer = MiddleRenderer;
